import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onRemoveContent", "contents", "onOpenAssetPicker", "onOpenPlaylistPicker"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import FormField from 'components/FormField';
import { Menu, MenuButton, MenuItem, MenuList } from 'components/Menu';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Flex from 'components/Flex';
import ContentList from './ContentList';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ContentField(_ref) {
  var _otherProps$required;
  var onRemoveContent = _ref.onRemoveContent,
    _ref$contents = _ref.contents,
    contents = _ref$contents === void 0 ? [] : _ref$contents,
    onOpenAssetPicker = _ref.onOpenAssetPicker,
    onOpenPlaylistPicker = _ref.onOpenPlaylistPicker,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var menuId = useUniqueId();
  var hasNoContent = contents.length === 0;
  var isRequired = (_otherProps$required = otherProps.required) !== null && _otherProps$required !== void 0 ? _otherProps$required : true;
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    required: true,
    as: "fieldset",
    label: isRequired ? "".concat(t('form_content_plural'), " *") : t('form_content_plural'),
    horizontalLabelOffset: "xxs"
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [hasNoContent ? /*#__PURE__*/_jsx(Flex, {
        border: "dashed",
        borderRadius: "small",
        p: "s",
        minHeight: 61,
        children: /*#__PURE__*/_jsx(Text, {
          dimmed: true,
          children: t('error_no_content_selected')
        })
      }) : /*#__PURE__*/_jsx(ContentList, {
        contents: contents,
        onRemoveContent: onRemoveContent
      }), /*#__PURE__*/_jsxs(Menu, {
        id: menuId,
        children: [/*#__PURE__*/_jsx(MenuButton, {
          iconRight: "chevron",
          icon: "plus",
          "aria-label": t('actions_add_content'),
          size: "medium",
          children: t('actions_add_content')
        }), /*#__PURE__*/_jsxs(MenuList, {
          children: [/*#__PURE__*/_jsx(MenuItem, {
            onClick: onOpenAssetPicker,
            children: t('actions_add_asset')
          }), /*#__PURE__*/_jsx(MenuItem, {
            onClick: onOpenPlaylistPicker,
            children: t('actions_add_playlist')
          })]
        })]
      })]
    })
  }));
}
export default ContentField;